<template>
    <LoginContent>
        <div class="row justify-content-center">
            <div class="col-12 col-lg-8 col-xl-8">
                <div class="min-height-100vh has-header d-flex align-items-center">
                    <div class="form-content form-team-content w-100 white-content" v-if="!abono">
                        <div class="h1 mb-4 text-center text-uppercase">{{ $t('header.mi_abono') }}</div>
                        <div class="thumb-container absolute" :style='"background-image: url(" + footer.logo + ")"'></div>
                        <ContentOrLoading>
                            <BuscarAbonado :error="mensaje" @buscarAbonado="buscarAbono" :loading="loading" :data="data" />
                            <span class="error" v-if="mensaje">{{ mensaje }}</span>
                        </ContentOrLoading>
                       
                    </div>
                    <div class="form-content form-team-content w-100 white-content" v-else>
                        <div class="h1 mb-4 text-center text-uppercase">{{ $t('header.mi_abono') }}</div>
                        <div class="thumb-container absolute" :style='"background-image: url(" + footer.logo + ")"'></div>
                        <div class="row mt-3">
                            <div class="col-md-3 col-sm-12 my-auto text-center pb-3">
                                <img :src="'data:image/png;base64, ' + abono.attributes.QRImage" alt="" style="height: 150px">
                            </div>
                            <div class="col-md-9 col-sm-12" style="font-weight: bold;">
                                <div class="row">
                                    <div class="col-12">
                                        <span class="altcolor">Nº de abonado:</span> {{ abono.info.Num_Socio }}
                                    </div>
                                    <div class="col-12">
                                        <span class="altcolor">Nombre:</span> {{ abono.info.Nombre }}
                                    </div>
                                    <div class="col-12">
                                        <span class="altcolor">EMail:</span> {{ abono.info.EMail }}
                                    </div>
                                    <div class="col-12">
                                        <span class="altcolor">Dirección:</span> {{ abono.info.Direccion }}
                                    </div>
                                    <div class="col-12">
                                        <span class="altcolor">Fecha de alta:</span> {{ abono.info.Fecha_Alta }}
                                    </div>
                                    <div class="col-12">
                                        <span class="altcolor">Provincia:</span> {{ abono.info.Provincia }}
                                    </div>
                                    <div class="col-12">
                                        <span class="altcolor">Localidad:</span> {{ abono.info.Localidad }}
                                    </div>
                                    <div class="col-12">
                                        <span class="altcolor">Abono:</span> {{ abono.info.Tipo_Abono }}
                                    </div>
                                    <div class="col-12">
                                        <span class="altcolor">Fila:</span> {{ abono.info.Fila }}
                                    </div>
                                    <div class="col-12">
                                        <span class="altcolor">Asiento:</span> {{ abono.info.Asiento }}
                                    </div>
                                    <div class="col-12">
                                        <span class="altcolor">Zona:</span> {{ abono.info.ZonaNombre }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mt-3 d-flex justify-content-between">
                                <a class="button" target="_blank" :href="getPdfEnlace(abono)"><i class="far fa-file-pdf"></i> Descargar PDF</a>
                                <button type="button" @click="showModal()" class="button" name="button" :disabled="loading">Cambiar PIN</button>
                            </div>
                            <CambioPin @close="closeModal()" @cambiarPin="cambiarPIN" :id_persona="data.id_persona" :pin_actual="data.pin" :loading="loading"></CambioPin>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </LoginContent>
</template>

<script>
import LoginContent from '@/components/frontend/components/LoginContent';
import BuscarAbonado from '@/components/frontend/lfp/BuscarAbonado';
import CambioPin from './modals/CambioPin.vue';

export default {
    data() {
        return {
            mensaje: null,
            loading: false,
            abono: null,
            data: {}
        }
    },
    head: {
        title: function() {
            return {
                inner: 'Mi abono',
                complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
            }
        },
        meta: function() {
            return [
                {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
            ]                
        },
    },
    computed: {
        footer() {
            return this.$store.getters.getFooter;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    methods: {
        buscarAbono(data) { 
            this.data = data;
            this.loading = true;
            data.filters = data;
            data.tid = this.configuracion.hash_teatro;
          
            this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar.lfp'), data).then(res => {
                this.abono = res.data;
                this.loading = false;
            }).catch(error => {
                this.mensaje = error.response.data.message;
                this.loading = false;                 
            });
        },
        getPdfEnlace(abono) {
            return this.config.API_BASE + '/lfp/front/abono/pdf?tid=' + this.configuracion.hash_teatro + '&id_persona=' + this.data.id_persona + '&pin=' + this.data.pin;
        },
        showModal(){ 
            this.$modal.show('cambioPin');
        },
        closeModal(){
            this.mensaje = null;
            this.$modal.hide('cambioPin');
        },
        cambiarPIN(data){
            this.loading = true;
            data.tid = this.configuracion.hash_teatro;

            this.$store.dispatch(this.config.getVuexAlias('lfp.abono.cambio.pin'), data).then(res => {
                this.loading = false;
                this.closeModal();
                this.$toast.success(res.data.message);
                this.data.pin = data.pin_new;
            }).catch(error => {
                this.$toast.error(error.response.data.message);
                this.loading = false;                 
            });
        }
    },
    components: {
        LoginContent, BuscarAbonado, CambioPin
    }
}
</script>
